import React from 'react';
import axios from 'axios';
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId, getcompanyId } from "../../utility/tokenUtility";

function GetallLov({ rowData }) {
  return <div>GetallLov</div>;
}

const token = getAuthToken("id_token");
const facilityId = getFacilityId();
const companyId = getcompanyId();
const config = {
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  },
};

const fetchServiceOptions = async () => {
  try {
    const response=await axios.get(`${MasterGraph}/api/masters/GetMasters/${companyId}/${facilityId}`,config
    );
    const serviceData = response.data.masservicedetails;
    const options = serviceData.map((service) => ({
      value: service.service,
      label: service.service,
      id: service.id,
    }));
    return options;
  } catch (error) {
    console.error("Error fetching service options:", error);
    return []; 
  }
};

export default GetallLov;
export { 
    fetchServiceOptions,
};
